import React from 'react'
import PropTypes from 'prop-types'

import { StyledTile } from 'components/product/styled';

function Tile({ listItem }) {
  return (
    <StyledTile>
      <p>
        {listItem}

      </p>
    </StyledTile>
  )
}

Tile.propTypes = {
  listItem: PropTypes.string
}

export default Tile

